import { Checkbox } from './Checkbox';

export function MultiCheck({ options, selected, onToggle }: { options: { id: string; name: string }[]; selected: string[]; onToggle: (id: string) => void }) {
  return (
    <div className="max-h-48 space-y-1 overflow-y-auto rounded-xl border border-border p-2">
      {options.map((o) => (
        <div key={o.id} className="rounded-lg px-2 py-1.5 hover:bg-canvas"><Checkbox checked={selected.includes(o.id)} onChange={() => onToggle(o.id)} label={o.name} /></div>
      ))}
      {options.length === 0 && <p className="px-2 py-1.5 text-sm text-muted">Nothing to select.</p>}
    </div>
  );
}

export function toggleInList(list: string[], set: (v: string[]) => void, id: string) {
  set(list.includes(id) ? list.filter((x) => x !== id) : [...list, id]);
}
